module.exports = __webpack_public_path__ + "static/media/weather.5e9ebfc2.png";